import React, { useEffect, useState } from "react";

/* Aviso de cookies discreto: abajo del todo, sobre una franja propia,
   sin tapar el contenido mientras se lee la página. */
const CookieBanner = ({ language }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("cookie-consent")) setVisible(true);
    } catch (e) {
      /* navegación privada o almacenamiento bloqueado: no insistimos */
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem("cookie-consent", "accepted");
    } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  const t =
    language === "de"
      ? {
          text:
            "Diese Seite verwendet nur technisch notwendige Cookies. Kein Tracking, keine Weitergabe an Dritte.",
          btn: "Verstanden",
        }
      : {
          text:
            "Este sitio usa solo cookies técnicas necesarias. Sin seguimiento y sin cesión a terceros.",
          btn: "Entendido",
        };

  return (
    <div
      role="region"
      aria-label="Cookies"
      className="fixed inset-x-0 bottom-0 z-50 bg-noche/95 backdrop-blur-sm border-t border-borde"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <p className="text-sm text-hueso/70 max-w-2xl">{t.text}</p>
        <button
          onClick={accept}
          className="rotulo shrink-0 border border-borde hover:border-lobo text-hueso/80 hover:text-hueso px-5 py-2 transition-colors self-start sm:self-auto"
        >
          {t.btn}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
